export default {
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.isBannerMobile = window.innerWidth <= 768;
      })
    }
  },
  computed: {
    randomBanner() {
      const TOTAL_BANNER = 2;
      const randomIndex = Math.floor(Math.random() * TOTAL_BANNER) + 1;
      return `/img/banner/banner_${randomIndex}.gif`;
    },
    randomVideoBanner() {
      const TOTAL_BANNER = 3;
      const randomIndex = Math.floor(Math.random() * TOTAL_BANNER) + 1;
      return `/video/banner/pickafund${randomIndex}.mp4`;
    },
  },
  data() {
      return {
          isBannerMobile: window.innerWidth <= 768
      }
  },
  mounted() {
      window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
      window.removeEventListener('resize', this.handleResize)
  }
};
